// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay, {
    DataViewLoadingOverlayProps,
} from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
/* Store Custom Code - End */

export interface OrderLayoutProps extends ExpandStyles<OrderLayoutStyles>, DataViewLoadingOverlayProps {
    id: string;
}

export interface OrderLayoutStyles {
    loadingOverlay?: LoadingOverlayProps;
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumnMobile?: GridItemProps;
    sideColumnDesktop?: GridItemProps;
    sideColumnWrapper?: InjectableCss;
    // Store Custom Code
    errorInfosBox?: InfosBoxProps;
    gridItem?: GridItemProps;
    gridItemOrderTotal?: GridItemProps;
}

export const orderLayoutStyles: OrderLayoutStyles = {
    loadingOverlay: { minHeight: 150 },
    /* Store Custom Code - Start */
    container: {
        gap: 0,
        offsetCss: css`
            justify-content: flex-end;
        `,
    },
    /* Store Custom Code - End */
    mainColumn: {
        width: [12, 12, 7, 8, 9],
        printWidth: 12,
    },
    sideColumnMobile: {
        width: [12, 12, 0, 0, 0],
        printWidth: 0,
    },
    sideColumnDesktop: {
        width: [0, 0, 5, 4, 3],
        printWidth: 12,
    },
    sideColumnWrapper: {
        css: css`
            position: sticky;
            top: ${pxToRem(20)};
            width: 100%;
        `,
    },
    /* Store Custom Code - Start */
    errorInfosBox: { type: "error" },
    gridItem: { width: 12 },
    gridItemOrderTotal: {
        width: [12, 7, 7, 6, 5],
        printWidth: 6,
        css: css`
            @media print {
                display: none !important;
            }
        `,
    },
    /* Store Custom Code - End */
};

const OrderLayout: FC<OrderLayoutProps> = ({
    id,
    loading,
    loadComplete,
    dataView,
    preload,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(orderLayoutStyles, extendedStyles, overridedStyles);

    return (
        <DataViewLoadingOverlay
            dataView={dataView}
            loading={loading}
            loadComplete={loadComplete}
            preload={preload}
            {...styles.loadingOverlay}
        >
            <GridContainer {...styles.container}>
                {/* Store Custom Code - Start */}
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Content01" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Content02" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Content03" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItemOrderTotal}>
                    <Zone zoneName="Content04" contentId={id} />
                </GridItem>
                {/* Store Custom Code - End */}
            </GridContainer>
        </DataViewLoadingOverlay>
    );
};

export default OrderLayout;
